var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.233,
    height: 45,
    viewBox: "0 0 43.233 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.842 -280.596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.024,280.6A7.254,7.254,0,0,0,2.77,287.85a9.842,9.842,0,0,0,.171,1.8H17.1a9.84,9.84,0,0,0,.176-1.8A7.254,7.254,0,0,0,10.024,280.6Zm17.738,0a7.254,7.254,0,0,0-7.254,7.254,9.841,9.841,0,0,0,.171,1.8H34.84a9.84,9.84,0,0,0,.175-1.8A7.254,7.254,0,0,0,27.762,280.6Z",
    transform: "translate(3.529 0)",
    fill: "#ffc861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29,281.853a3.362,3.362,0,0,0-3.37,3.37v2.6H20.335v-2.6a3.362,3.362,0,0,0-3.37-3.37Z",
    transform: "translate(9.295 2.3)",
    fill: "#ffca3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.116,2.774a7.3,7.3,0,0,0-.064.916,9.857,9.857,0,0,0,.171,1.8H23.407a9.856,9.856,0,0,0,.176-1.8,7.3,7.3,0,0,0-.056-.916Z",
    transform: "translate(15.025 284.175)",
    fill: "#ffca3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.566,2.774a1.5,1.5,0,1,0,0,3h6.891V3.361a3.385,3.385,0,0,0-.06-.587Z",
    transform: "translate(13.222 284.175)",
    fill: "#ff9700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9,283.7H38.943A5.048,5.048,0,0,1,44,288.763v26.012a5.048,5.048,0,0,1-5.059,5.059H5.9a5.048,5.048,0,0,1-5.059-5.059V288.763A5.048,5.048,0,0,1,5.9,283.7Z",
    transform: "translate(0 5.688)",
    fill: "#ef6356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.661,295.57a1.5,1.5,0,0,0-1,2.549H32.747a5.057,5.057,0,0,0,4.4-2.549H5.81a1.465,1.465,0,0,0-.149,0Z",
    transform: "translate(6.194 27.402)",
    fill: "#d85750"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.845 289.409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.843,8.584V16.8h17.5V8.584Zm25.725,0V16.8h17.5V8.584Z",
    transform: "translate(-0.843 5.4)",
    fill: "#ffca3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.028,3.643V39.83h8.221V3.643Z",
    transform: "translate(10.477 -3.643)",
    fill: "#ffc861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.028,15.527V18.08h8.221V15.527Z",
    transform: "translate(10.477 18.107)",
    fill: "#ffca3a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.96b73cc550d143ddd70d663278602eb3.svg";
export { ForwardRef as ReactComponent };